import { tv } from "tailwind-variants";

export const getSentenceClass = tv({
  base: [
    "max-w-lg rounded-xl p-4 leading-relaxed lg:max-w-5xl lg:p-8 lg:pb-6 lg:text-xl",
    "animate-duration-200! group-[.animate-intersected-in]/intersected:animate-fade-up",
  ],
  variants: {
    variant: {
      neutral: "bg-tertiary-50 text-tertiary-600",
      positive: "bg-success-100 text-success-700",
      alert: "bg-error-100 text-error-700",
    },
  },
});

export const getIconClass = tv({
  base: [
    "text-xl lg:text-[26px]",
    "animate-delay-200! animate-duration-300! lg:group-[.animate-intersected-in]/intersected:animate-jump-in",
  ],
});

export const getSentenceTextClass = tv({
  base: ["animate-delay-200! animate-duration-500! group-[.animate-intersected-in]/intersected:animate-fade"],
});
